// Mobile navigation overlay
(function () {
    var btn    = document.getElementById('mobileMenuBtn');
    var nav    = document.getElementById('mobileNav');
    var navRow = document.getElementById('mainNavRow');
    if (!btn || !nav) return;

    // Position the overlay to start at the bottom of the nav row,
    // so it slides down over the search bar (not below the full header)
    function setMenuTop() {
        nav.style.top = (navRow ? navRow.offsetHeight : 72) + 'px';
    }
    setMenuTop();
    window.addEventListener('resize', setMenuTop);

    function openMenu() {
        nav.setAttribute('aria-hidden', 'false');
        btn.setAttribute('aria-expanded', 'true');
        btn.setAttribute('aria-label', 'Close menu');
    }

    function closeMenu() {
        nav.setAttribute('aria-hidden', 'true');
        btn.setAttribute('aria-expanded', 'false');
        btn.setAttribute('aria-label', 'Open menu');
    }

    btn.addEventListener('click', function () {
        btn.getAttribute('aria-expanded') === 'true' ? closeMenu() : openMenu();
    });

    // Close when any nav link is tapped
    nav.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', closeMenu);
    });

    // Close on click outside
    document.addEventListener('click', function (e) {
        if (btn.getAttribute('aria-expanded') === 'true' &&
            !nav.contains(e.target) && !btn.contains(e.target)) {
            closeMenu();
        }
    });
}());

// Generic delete/action confirmation via data-confirm attribute.
// Usage: <form data-confirm="Are you sure?"> — no inline onsubmit needed.
document.addEventListener('submit', function (e) {
    const form = e.target;
    const message = form.dataset.confirm;
    if (message && !window.confirm(message)) {
        e.preventDefault();
    }
});

// Add-to-basket helper (used by ProductDetails and any future pages)
window.addItemToBasket = async function (productId, btn) {
    var tokenEl = document.querySelector('[name="__RequestVerificationToken"]');
    var token = tokenEl ? tokenEl.value : '';
    var originalText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding\u2026'; }
    var res = await fetch('/basket?handler=Add', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'productId=' + productId + '&qty=1&__RequestVerificationToken=' + encodeURIComponent(token)
    });
    if (res.ok) {
        window.dispatchEvent(new CustomEvent('basket-updated', { detail: { delta: 1 } }));
    }
    if (btn) {
        btn.textContent = res.ok ? 'Added!' : 'Error';
        setTimeout(function () { btn.textContent = originalText; btn.disabled = false; }, 1500);
    }
};

// Basket dropdown toggle (uses CSS-animated .open class, not hidden)
(function () {
    var btn = document.getElementById('basketBtn');
    var panel = document.getElementById('basketPanel');
    if (!btn || !panel) return;

    btn.addEventListener('click', function (e) {
        e.stopPropagation();
        panel.classList.toggle('open');
    });

    document.addEventListener('click', function (e) {
        if (!panel.contains(e.target)) {
            panel.classList.remove('open');
        }
    });
}());

// Turnstile — enable/disable the submit button based on verification state.
// Forms with Turnstile must render their submit button with id="turnstileSubmit"
// and the disabled attribute set initially.
window.onTurnstilePassed = function () {
    var btn = document.getElementById('turnstileSubmit');
    if (btn) btn.disabled = false;
};
window.onTurnstileExpired = function () {
    var btn = document.getElementById('turnstileSubmit');
    if (btn) btn.disabled = true;
};
window.onTurnstileError = function () {
    var btn = document.getElementById('turnstileSubmit');
    if (btn) btn.disabled = true;
};

// Set basket badge to an absolute count value
function setBasketBadge(count) {
    ['basketCount', 'mobileBasketCount', 'mobileHeaderBasketCount'].forEach(function (id) {
        var el = document.getElementById(id);
        if (!el) return;
        el.textContent = count;
        el.classList.toggle('hidden', count === 0);
    });
    var panelCount = document.getElementById('basketPanelCount');
    if (panelCount) panelCount.textContent = count;
}

// HTMX Add-to-Basket: fire basket-updated with the actual qty after a successful add
document.addEventListener('htmx:afterRequest', function (e) {
    if (!e.detail.successful) return;
    var path = e.detail.requestConfig && e.detail.requestConfig.path || '';
    if (path.indexOf('/basket') === -1 || path.indexOf('Add') === -1) return;
    var form = e.detail.elt;
    var qtyEl = form && form.querySelector ? form.querySelector('[name="qty"]') : null;
    var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
    window.dispatchEvent(new CustomEvent('basket-updated', { detail: { delta: qty } }));
});

// Update basket badge counts when an item is added client-side
window.addEventListener('basket-updated', function (e) {
    var delta = (e.detail && e.detail.delta) || 1;

    ['basketCount', 'mobileBasketCount', 'mobileHeaderBasketCount'].forEach(function (id) {
        var el = document.getElementById(id);
        if (!el) return;
        var current = parseInt(el.textContent, 10) || 0;
        current += delta;
        el.textContent = current;
        el.classList.toggle('hidden', current === 0);
    });

    var panelCount = document.getElementById('basketPanelCount');
    if (panelCount) {
        panelCount.textContent = (parseInt(panelCount.textContent, 10) || 0) + delta;
    }
});

// Update badge to an absolute count sent via HX-Trigger header (basket remove/update)
document.addEventListener('basket-count-set', function (e) {
    if (e.detail && typeof e.detail.count === 'number') setBasketBadge(e.detail.count);
});

// Initialise basket badge from server on every page load.
// This corrects stale counts baked into output-cached pages (Shop, ProductDetails).
document.addEventListener('DOMContentLoaded', function () {
    fetch('/basket?handler=Count')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) { if (data && typeof data.count === 'number') setBasketBadge(data.count); })
        .catch(function () { /* non-critical — silently ignore */ });
    observeScrollRevealCards();
});

// Scroll-reveal: fade cards in as they enter the viewport
(function () {
    var revealCount = 0;
    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var el = entry.target;
            el.style.animationDelay = (revealCount * 0.06) + 's';
            el.classList.add('fade-in-up');
            revealCount++;
            observer.unobserve(el);
        });
    }, { threshold: 0.08 });

    window.observeScrollRevealCards = function () {
        document.querySelectorAll('.scroll-reveal:not([data-observed])').forEach(function (el) {
            el.setAttribute('data-observed', '1');
            observer.observe(el);
        });
    };
}());

// Re-observe after Alpine renders x-for cards (shop page)
document.addEventListener('alpine:initialized', function () {
    if (window.observeScrollRevealCards) window.observeScrollRevealCards();
});

// Mobile live search — shared factory for portrait (below-nav) and landscape (inline-nav) inputs
(function () {
    function initMobileSearch(inputId, dropdownId, resultsId, seeAllId, seeAllLinkId) {
        var input = document.getElementById(inputId);
        if (!input) return;
        var dropdown   = document.getElementById(dropdownId);
        var results    = document.getElementById(resultsId);
        var seeAll     = document.getElementById(seeAllId);
        var seeAllLink = document.getElementById(seeAllLinkId);
        var debounceTimer = null;
        var currentQuery  = '';

        function esc(str) {
            return (str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
        }
        function closeDropdown() {
            if (dropdown) dropdown.classList.add('hidden');
            if (results)  results.innerHTML = '';
            if (seeAll)   seeAll.classList.add('hidden');
        }
        function renderResults(items, q) {
            if (!dropdown || !results) return;
            if (!items || !items.length) {
                results.innerHTML = '<li class="px-4 py-3 text-sm text-muted">No results found</li>';
                if (seeAll) seeAll.classList.add('hidden');
                dropdown.classList.remove('hidden');
                return;
            }
            results.innerHTML = items.map(function (p) {
                var img = p.image
                    ? '<img src="' + esc(p.image) + '" alt="" class="h-10 w-10 rounded object-cover flex-shrink-0 border border-muted/20" />'
                    : '<div class="h-10 w-10 rounded bg-brand/10 flex-shrink-0"></div>';
                return '<li><a href="/shop/' + esc(p.slug) + '" class="flex items-center gap-3 px-4 py-2.5 hover:bg-brand/5 transition">' +
                    img + '<div class="flex-1 min-w-0"><p class="text-sm font-medium truncate">' + esc(p.name) + '</p>' +
                    '<p class="text-xs text-muted">' + esc(p.price) + '</p></div></a></li>';
            }).join('');
            if (seeAllLink) seeAllLink.href = '/shop?q=' + encodeURIComponent(q);
            if (seeAll) seeAll.classList.remove('hidden');
            dropdown.classList.remove('hidden');
        }
        function fetchResults(q) {
            fetch('/api/products/search?q=' + encodeURIComponent(q))
                .then(function (r) { return r.ok ? r.json() : []; })
                .then(function (data) { if (input.value.trim() === q) renderResults(data, q); })
                .catch(closeDropdown);
        }
        input.addEventListener('input', function () {
            var q = input.value.trim();
            if (q === currentQuery) return;
            currentQuery = q;
            clearTimeout(debounceTimer);
            if (q.length < 2) { closeDropdown(); return; }
            debounceTimer = setTimeout(function () { fetchResults(q); }, 250);
        });
        input.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') { input.value = ''; currentQuery = ''; closeDropdown(); }
            if (e.key === 'Enter') { var q = input.value.trim(); if (q) window.location.href = '/shop?q=' + encodeURIComponent(q); }
        });
        document.addEventListener('click', function (e) {
            if (dropdown && !dropdown.contains(e.target) && e.target !== input) closeDropdown();
        });
    }

    initMobileSearch('mobileSearchInput',    'mobileSearchDropdown', 'mobileSearchResults', 'mobileSearchSeeAll',  'mobileSearchSeeAllLink');
    initMobileSearch('mobileNavSearchInput', 'mobileNavDropdown',    'mobileNavSearchResults', 'mobileNavSeeAll',  'mobileNavSeeAllLink');
}());

// Nav live search — expands on icon click, fetches dropdown results as user types
(function () {
    var wrapper   = document.getElementById('navSearchWrapper');
    var btn       = document.getElementById('navSearchBtn');
    var expanded  = document.getElementById('navSearchExpanded');
    var input     = document.getElementById('navSearchInput');
    var dropdown  = document.getElementById('navSearchDropdown');
    var results   = document.getElementById('navSearchResults');
    var seeAll    = document.getElementById('navSearchSeeAll');
    var seeAllLink = document.getElementById('navSearchSeeAllLink');

    if (!btn || !expanded || !input) return;

    var debounceTimer = null;
    var currentQuery  = '';

    function openSearch() {
        expanded.classList.remove('hidden');
        expanded.classList.add('flex');
        input.focus();
    }

    function closeSearch() {
        expanded.classList.add('hidden');
        expanded.classList.remove('flex');
        input.value = '';
        currentQuery = '';
        closeDropdown();
    }

    function closeDropdown() {
        if (dropdown) dropdown.classList.add('hidden');
        if (results)  results.innerHTML = '';
        if (seeAll)   seeAll.classList.add('hidden');
    }

    function escHtml(str) {
        return (str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    function renderResults(items, q) {
        if (!items || !items.length) {
            results.innerHTML = '<li class="px-4 py-3 text-sm text-muted">No results found</li>';
            seeAll.classList.add('hidden');
            dropdown.classList.remove('hidden');
            return;
        }
        results.innerHTML = items.map(function (item) {
            var img = item.image
                ? '<img src="' + escHtml(item.image) + '" alt="" class="h-10 w-10 rounded object-cover flex-shrink-0 border border-muted/20" />'
                : '<div class="h-10 w-10 rounded bg-brand/10 flex-shrink-0"></div>';
            return '<li><a href="/shop/' + escHtml(item.slug) + '" class="flex items-center gap-3 px-4 py-2.5 hover:bg-brand/5 transition">' +
                img +
                '<div class="flex-1 min-w-0">' +
                '<p class="text-sm font-medium truncate">' + escHtml(item.name) + '</p>' +
                '<p class="text-xs text-muted">' + escHtml(item.price) + '</p>' +
                '</div></a></li>';
        }).join('');
        seeAllLink.href = '/shop?q=' + encodeURIComponent(q);
        seeAll.classList.remove('hidden');
        dropdown.classList.remove('hidden');
    }

    function fetchResults(q) {
        fetch('/api/products/search?q=' + encodeURIComponent(q))
            .then(function (r) { return r.ok ? r.json() : []; })
            .then(function (data) {
                if (input.value.trim() !== q) return; // stale response
                renderResults(data, q);
            })
            .catch(closeDropdown);
    }

    btn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (expanded.classList.contains('hidden')) {
            openSearch();
        } else {
            var q = input.value.trim();
            if (q) {
                window.location.href = '/shop?q=' + encodeURIComponent(q);
            } else {
                closeSearch();
            }
        }
    });

    input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { closeSearch(); return; }
        if (e.key === 'Enter') {
            var q = input.value.trim();
            if (q) window.location.href = '/shop?q=' + encodeURIComponent(q);
        }
    });

    input.addEventListener('input', function () {
        var q = input.value.trim();
        if (q === currentQuery) return;
        currentQuery = q;
        clearTimeout(debounceTimer);
        if (q.length < 2) { closeDropdown(); return; }
        debounceTimer = setTimeout(function () { fetchResults(q); }, 250);
    });

    document.addEventListener('click', function (e) {
        if (wrapper && !wrapper.contains(e.target)) closeSearch();
    });
}());
